var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3843 4220 c-65 -33 -111 -80 -141 -147 -16 -35 -17 -129 -20 -1335 l-2 -1298 -1298 -2 c-1206 -3 -1300 -4 -1335 -20 -69 -31 -115 -76 -148 -143 -29 -59 -31 -71 -27 -137 3 -46 12 -88 26 -113 24 -47 83 -105 132 -131 34 -18 92 -19 1530 -19 l1495 0 46 27 c50 29 98 79 126 131 17 30 18 116 18 1527 0 1438 -1 1496 -19 1530 -26 49 -84 108 -131 133 -27 13 -65 22 -115 24 -69 4 -80 2 -137 -27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRight);
export default __webpack_public_path__ + "static/media/bottom-right.3af06d53150220d678c1bfccb13bc3c3.svg";
export { ForwardRef as ReactComponent };